var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0933 14.0207H21.7017C21.8497 14.0207 21.9698 13.9075 21.9698 13.7681V12.2525C21.9698 12.113 21.8497 11.9999 21.7017 11.9999H20.0933C18.4678 11.9999 17.1446 13.2462 17.1446 14.7785V16.5466H15.2682C15.1202 16.5466 15.0001 16.6598 15.0001 16.7992V18.3148C15.0001 18.4543 15.1202 18.5674 15.2682 18.5674H17.1446V23.872C17.1446 24.0114 17.2647 24.1246 17.4127 24.1246H19.0211C19.169 24.1246 19.2891 24.0114 19.2891 23.872V18.5674H21.1656C21.2808 18.5674 21.3832 18.4977 21.4202 18.3946L21.9564 16.8791C21.9837 16.8023 21.9698 16.7174 21.9194 16.6512C21.8684 16.5855 21.788 16.5466 21.7017 16.5466H19.2891V14.7785C19.2891 14.3607 19.6499 14.0207 20.0933 14.0207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5ca0cdc147f3e89a0a37447330e5b218.svg";
export { ForwardRef as ReactComponent };